<template>
  <div>
    <v-data-table 
          :headers="headersAcordo" 
          :items="devedor.acordos?devedor.acordos:[]"
          hide-default-footer
          disable-pagination>
      <template v-slot:item="props">
        <tr :class="getColorEndereco(props.item)" @click="abrirAcordo(props.item)">
          <td>{{props.item.user?props.item.user.name:''}}</td>
          <td>{{props.item.cliente?props.item.cliente.Nome:''}}</td>
          <td>{{props.item.ValorAcordo | currency}}</td>
          <td>{{getProposta(props.item.proposta)}}</td>
          <td>{{getPagamento(props.item.tipoPagamento)}}</td>
          <td>{{props.item.ValorDivida | currency}}</td>
          <td>{{props.item.detalhes}}</td>
          <td>{{getStatusAcordo(props.item.StatusAcordo)}}</td>
          <td>{{props.item.createdAt | moment("DD/MM/YYYY HH:mm")}}</td>
        </tr>
      </template>
      
    </v-data-table>

    
    <v-dialog v-model="dialogParcela" persistent max-width="800">
      <v-card>
        <v-card-title class="headline">Parcelas</v-card-title>
        <v-card-text>
          <v-data-table :headers="headersParcelas"
            :items="acordo.parcelas" 
            hide-default-footer
            disable-pagination>
            <template v-slot:item.numero="{ item }">
              <span>{{ item.numero+'/'+acordo.parcelas.length}}</span>
            </template>
            <template v-slot:item.vencimento="{ item }">
              <span>{{ item.vencimento | moment("DD/MM/YYYY")}}</span>
            </template>
            <template v-slot:item.valor="{ item }">
              <span>{{ item.valor | currency}}</span>
            </template>

            <template v-slot:item.boleto="{ item }">
              <v-btn small :disabled="desabilitarPagamento(acordo, item)" @click="gerarBoleto(item)">{{item.juno||item.secure_url?'Imprimir':'Gerar'}}</v-btn>
            </template>

            <!-- <template v-slot:item.email="{ item }">
              <v-btn small :disabled="acordo.StatusAcordo == '1' || acordo.StatusAcordo == '2' || acordo.StatusAcordo == '9' || !item.juno  || item.stPago == 'S'" @click="enviarEmail(item)" >Email</v-btn>
            </template> -->

            <template v-slot:item.stPago="{ item }">
              <span>{{ getStPago(item) }}</span>
            </template>
            <template v-slot:item.dtPagamento="{ item }">
              <span>{{item.dtPagamento | moment("DD/MM/YYYY") }}</span>
            </template>
          </v-data-table>
          <v-row>
            <v-col md="6" offset-md="3">
              Valor Total:
              <span>{{acordo.parcelas&&acordo.parcelas.length>0?acordo.parcelas.map((item) => {return item.valor}).reduce((prev, next) => {return (prev + next)}):0 | currency}}</span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="red darken-1" @click.native="dialogParcela = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="dialogError" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Observação</v-card-title>
        <v-card-text>{{ message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="blue darken-1" @click.native="dialogError = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirmation" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Confirmação</v-card-title>
        <v-card-text>Tem certeza que deseja excluir?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="red darken-1" @click.native="dialogConfirmation = false">Não</v-btn>
          <v-btn small color="blue darken-1" @click.native="deleteItem(excluindo)">Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
  </div>
</template>

<script>
  import { mapMutations } from "vuex";  
  import acordo from "@/services/acordo";
  import juno from "@/services/juno";
  import devedores from "@/services/devedores";
  import axios from "axios";

  export default {
    name: 'Endereco',
    data () {
      return {
        
        valid: true,
        acordo: {},
        dialogConfirmation:false,
        dialogError: false,
        dialogParcela: false,
        editando: false,
        message: "",
        excluindo: {},
        cep: {},
        headersAcordo: [
          {
            text: 'Nome Operador',
            align: 'left',
            sortable: true,
            value: 'user.name'
          },
          {
            text: 'Nome Empresa',
            align: 'left',
            sortable: true,
            value: 'cliente.Nome'
          },
          {
            text: 'Valor Acordo',
            align: 'left',
            sortable: true,
            value: 'ValorAcordo'
          },
          {
            text: 'Tipo Acordo',
            align: 'left',
            sortable: true,
            value: 'proposta'
          },
          {
            text: 'Tipo Pagamento',
            align: 'left',
            sortable: true,
            value: 'tipoPagamento'
          },
          {
            text: 'Saldo Inicial',
            align: 'left',
            sortable: true,
            value: 'ValorDivida'
          },
          {
            text: 'Comentarios',
            align: 'left',
            sortable: true,
            value: 'detalhes'
          },
          {
            text: 'Status Acordo',
            align: 'left',
            sortable: true,
            value: 'StatusAcordo'
          },
          {
            text: 'Data Acordo',
            align: 'left',
            sortable: true,
            value: 'createdAt'
          }
        ],
        headersParcelas: [{
            text: 'Numero',
            value: 'numero'
          },
          {
            text: 'Vencimento',
            value: 'vencimento'
          },
          {
            text: 'Valor',
            value: 'valor'
          },
          {
            text: 'Boleto',
            value: 'boleto'
          },
          // {
          //   text: 'Modo de Envio',
          //   value: 'email'
          // },
          {
            text: 'Status',
            value: 'stPago'
          },
          {
            text: 'Numero Boleto',
            value: 'numeroBoleto'
          },
          {
            text: 'Pagamento',
            value: 'dtPagamento'
          }
        ]
      }
    },
    computed: {
      devedor() {
        return this.$store.getters["devedor"];
      },
    },
    methods: {
      async abrirAcordo (acordo) {
        this.acordo = acordo;
        this.dialogParcela = true;
      },
      getColorEndereco (endereco) {
        if (endereco && endereco.hot) return 'red white--text';
      },
      desabilitarPagamento (acordo, item) {
        if (acordo.StatusAcordo == '1' || acordo.StatusAcordo == '2' || acordo.StatusAcordo == '9' || item.stPago == 'S') {
          return true;
        } else {
          let retorno = false;
          acordo.parcelas.forEach(parcela => {
            if (parcela.numero == (item.numero-1) && parcela.stPago == "N") {
              retorno = true;
            }
          });
          return retorno;
        }
      },
      enviarEmail (item) {
        console.log(item);
      },
      async gerarBoleto (item) {
        if (item.secure_url) {
          
          axios.get(item.secure_url).then((response) => {
            window.open(item.secure_url,'_blank');
          }).catch(async (error)  => {
            let response = await juno.imprimirBoletosBB(item);
            window.open(response.secure_url,'_blank');
          })
        } else {
            let response = await juno.gerarBoletoBB(item);
            if (response) {
              if (response&&response.data&&response.data.erros) {
                this.setError(response.data.erros);
                return;
              }
              
              this.dialogParcela = false;
              this.$forceUpdate();
              this.setDevedor(await devedores.getDevedoreId(this.acordo.devedor));
              this.setError('Boleto gerado com sucesso!');
            }
        }
      },
      getStatusAcordo (status) {
        if (status == 1) {
          return 'Processo Cobrança';
        } else if (status == 2) {
          return 'Aguardando Aprovação';
        } else if (status == 3) {
          return 'Acordo Vigente';
        } else if (status == 4) {
          return 'Acordo em Atraso';
        } else if (status == 9) {
          return 'Acordo Cancelado';
        } else if (status == 6) {
          return 'Acordo Liquidado';
        }
      },
      getProposta (proposta) {
        if (proposta == 1) {
          return 'Fixa';
        } else if (proposta == 2) {
          return 'Exceção';
        } else if (proposta == 3) {
          return 'Gerado Devedor';
        }
      },
      getStPago (item) {
        if ((item.juno && item.juno.payments && item.juno.payments.length > 0) || item.stPago == 'S') {
          return 'Pago';
        }
        if (item.secure_url) {
          return 'Boleto BB';
        } 
        if (!item.juno) {
          return 'Boleto não Gerado';
        }
        
        if (moment(item.juno.dueDate) < moment()) {
          return 'Atraso';
        }
        if (item.stPago == 'N') {
          return 'Não Pago';
        } 
      },
      getPagamento (pagamento) {
        if (pagamento == 1) {
          return 'Boleto';
        } else if (pagamento == 2) {
          return 'Deposito';
        } else if (pagamento == 3) {
          return 'Escritório';
        } else if (pagamento == 4) {
          return 'Na Loja';
        } else if (pagamento == 5) {
          return 'Pix';
        }
      },
      ...mapMutations({
        setLoading: "setLoading",
        setError: "setError",
        setDevedor: "setDevedor",
      })
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/cobranca/Acordos.vue